"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _create = require("./create");

var _csrf = require("./csrf");

var _userUtils = require("./user-utils");

var _default = {
  create: _create.create,
  createProxy: _create.createProxy,
  getCurrentUser: _userUtils.getCurrentUser,
  generateCSRFToken: _csrf.generateCSRFToken
};
exports["default"] = _default;